"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Calendar_1 = require("office-ui-fabric-react/lib/Calendar");
var Callout_1 = require("office-ui-fabric-react/lib/Callout");
var TextField_1 = require("office-ui-fabric-react/lib/TextField");
var Button_1 = require("office-ui-fabric-react/lib/Button");
var StringUtils_1 = require("@twii/common/lib/StringUtils");
var moment = require("moment");
var MomentField_styles_1 = require("./MomentField.styles");
var MomentField_classNames_1 = require("./MomentField.classNames");
var defaultFormats = [
    "DD/MM/YYYY",
    "D/M/YY",
    "D/MMM/YY",
    "D/MMMM/YY",
    "D/M/YYYY",
    "D/MMM/YYYY",
    "D/MMMM/YYYY",
    "D-M-YY",
    "D-MMM-YY",
    "D-MMMM-YY",
    "D-M-YYYY",
    "D-MMM-YYYY",
    "D-MMMM-YYYY",
    "D M YY",
    "D MMM YY",
    "D MMMM YY",
    "D M YYYY",
    "D MMM YYYY",
    "D MMMM YYYY",
    "YYYY-M-D",
    "MMM D YYYY",
    "MMM D, YYYY"
];
var defaultCalendarStrings = {
    months: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
    ],
    shortMonths: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
    ],
    days: [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
    ],
    shortDays: [
        "S",
        "M",
        "T",
        "W",
        "T",
        "F",
        "S"
    ],
    goToToday: "Go to today"
};
var Defaults = {
    calendarStrings: defaultCalendarStrings,
    formats: defaultFormats
};
exports.Defaults = Defaults;
var DefaultMomentFieldProps = {
    isRequired: false,
    isMonthPickerVisible: true
};
/**
 * The fabric date picker's not quite sufficient for our purposes - this lifts most of the code from there, with overrides where necessary
 */
var MomentField = /** @class */ (function (_super) {
    __extends(MomentField, _super);
    function MomentField(props) {
        var _this = _super.call(this, props) || this;
        _this._onSelectDate = function (date) {
            var v = moment(date, _this.state.format);
            _this.setState({
                selectedDate: date,
                text: _this._formatDate(date),
                calendarOn: false
            });
            if (_this.props.onSelectDate) {
                _this.props.onSelectDate(date);
            }
            if (_this.props.onChange) {
                _this.props.onChange(v);
            }
        };
        _this._onCalloutPositioned = function () {
            if (_this._calendarRef) {
                _this._calendarRef.focus();
            }
        };
        _this._onCalendarDismissed = function () {
            _this._dismissCalendar();
        };
        _this._onTextFieldChanged = function (text) {
            var v = StringUtils_1.isNotBlank(text) ? _this._parseDate(text) : undefined;
            _this.setState({
                selectedDate: v && v.isValid() ? v.toDate() : null,
                text: text,
                format: v && v.isValid() ? String(v.creationData().format) : _this.formats[0]
            });
            if (_this.props.onChange) {
                _this.props.onChange(v);
            }
        };
        _this._onClickCalendarButton = function () {
            _this.setState({ calendarOn: !_this.state.calendarOn });
        };
        _this._onCalendarRef = function (ref) {
            _this._calendarRef = ref;
        };
        _this._onCalloutTargetRef = function (ref) {
            _this._calloutTargetRef = ref;
        };
        _this._onRenderSuffix = function () {
            if (!_this.props.hideCalendar) {
                return (React.createElement("div", { className: _this._classNames.calendarButtonContainer, ref: _this._onCalloutTargetRef },
                    React.createElement(Button_1.IconButton, { className: _this._classNames.calendarButton, iconProps: { iconName: "Calendar" }, onClick: _this._onClickCalendarButton })));
            }
            return null;
        };
        var value = _this.props.value;
        var format = value ? String(value.creationData().format) : _this.formats[0];
        var text;
        if (value) {
            var input = value.creationData().input;
            if (input) {
                if (input instanceof Date) {
                    text = value.format(format);
                }
                else {
                    text = String(input);
                }
            }
        }
        _this.state = {
            selectedDate: value && value.isValid() ? value.toDate() : null,
            text: text || "",
            format: format,
            calendarOn: false
        };
        return _this;
    }
    MomentField.prototype.componentWillReceiveProps = function (nextProps) {
        var value = nextProps.value;
        var format = value ? String(value.creationData().format) : this.formats[0];
        var text;
        if (value) {
            var input = value.creationData().input;
            if (input) {
                if (input instanceof Date) {
                    text = value.format(format);
                }
                else {
                    text = String(input);
                }
            }
        }
        this.setState({
            selectedDate: value ? value.toDate() : null,
            text: text || "",
            format: format
        });
    };
    Object.defineProperty(MomentField.prototype, "formats", {
        get: function () {
            return this.props.formats && this.props.formats.length > 0 ? this.props.formats : Defaults.formats;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MomentField.prototype, "calendarStrings", {
        get: function () {
            return this.props.calendarStrings || Defaults.calendarStrings;
        },
        enumerable: true,
        configurable: true
    });
    MomentField.prototype._showCalendar = function () {
        this.setState({
            calendarOn: true
        });
    };
    MomentField.prototype._dismissCalendar = function () {
        this.setState({
            calendarOn: false
        });
    };
    MomentField.prototype._formatDate = function (date) {
        if (date) {
            return moment(date).format(this.state.format || this.formats[0]);
        }
        return "";
    };
    MomentField.prototype._parseDate = function (text) {
        return moment(text, this.formats, true);
    };
    MomentField.prototype.render = function () {
        this._classNames = MomentField_classNames_1.getClassNames(MomentField_styles_1.getStyles(null, this.props.styles), this.props.className);
        return (React.createElement("div", { className: this._classNames.root },
            React.createElement("div", { className: this._classNames.inputContainer },
                React.createElement(TextField_1.TextField, { className: this._classNames.textField, ariaLabel: this.props.ariaLabel, label: this.props.label, "aria-haspopup": true, required: this.props.isRequired, onChanged: this._onTextFieldChanged, placeholder: this.props.placeholder, readOnly: this.props.readOnly, disabled: this.props.disabled, value: this.state.text || "", onRenderLabel: this.props.onRenderLabel, onRenderSuffix: this._onRenderSuffix })),
            this.state.calendarOn &&
                (React.createElement(Callout_1.Callout, __assign({}, this.props.calloutProps, { target: this._calloutTargetRef, onDismiss: this._onCalendarDismissed, directionalHint: 4 /* bottomLeftEdge */, onPositioned: this._onCalloutPositioned }),
                    React.createElement(Calendar_1.Calendar, { strings: this.calendarStrings, value: this.state.selectedDate, onSelectDate: this._onSelectDate, isMonthPickerVisible: this.props.isMonthPickerVisible, ref: this._onCalendarRef, navigationIcons: { leftNavigation: "ChevronLeft", rightNavigation: "ChevronRight" } })))));
    };
    MomentField.defaultProps = DefaultMomentFieldProps;
    return MomentField;
}(React.Component));
exports.MomentField = MomentField;
